export default "__VITE_ASSET__Bw6Dp$bv__"